import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { FocusSection } from '../components/FocusSection';
import { TrustSection } from '../components/TrustSection';
import { ServicesSection } from '../components/ServicesSection';
import { OpeningHoursSection } from '../components/OpeningHoursSection';
import { SmileViewSection } from '../components/SmileViewSection';
import { TeamSection } from '../components/TeamSection';
import { BlogPreview } from '../components/BlogPreview';
import { AppointmentCTA } from '../components/AppointmentCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-off-white flex flex-col" data-id="element-229">
      <Navigation data-id="element-230" />
      <main className="flex-grow" data-id="element-231">
        <HeroSection data-id="element-232" />
        <WelcomeSection data-id="element-233" />
        <FocusSection data-id="element-234" />
        <TrustSection data-id="element-235" />
        <ServicesSection data-id="element-236" />
        <OpeningHoursSection data-id="element-237" />
        <SmileViewSection data-id="element-238" />
        <TeamSection data-id="element-239" />
        <BlogPreview data-id="element-240" />
        <AppointmentCTA data-id="element-241" />
      </main>
      <Footer data-id="element-242" />
    </div>;
}